// // // // import React from "react";

// // // // const testimonials = [
// // // //   {
// // // //     id: 1,
// // // //     name: "Ayşe Yıldız",
// // // //     image: "/images/users/4.png",
// // // //     text: "Halılarım tertemiz oldu, tam zamanında teslim edildi. Çok memnun kaldım."
// // // //   },
// // // //   {
// // // //     id: 2,
// // // //     name: "Mehmet Can",
// // // //     image: "/images/users/1.png",
// // // //     text: "Profesyonel ekip, hızlı servis. Koltuklarım ilk günkü gibi oldu."
// // // //   },
// // // //   {
// // // //     id: 3,
// // // //     name: "Zeynep Kaya",
// // // //     image: "/images/users/3.png",
// // // //     text: "Uygun fiyat, kaliteli hizmet. Perdelerim ışıl ışıl oldu. Teşekkürler!"
// // // //   },
// // // //   {
// // // //     id: 4,
// // // //     name: "Ahmet Demir",
// // // //     image: "/images/users/2.png",
// // // //     text: "Yorgan yıkama hizmeti gerçekten başarılıydı. Tavsiye ederim."
// // // //   },
// // // //   {
// // // //     id: 5,
// // // //     name: "Elif Karaca",
// // // //     image: "/images/users/6.png",
// // // //     text: "Her seferinde memnun kalıyorum. Hijyen ve kalite bir arada."
// // // //   },
// // // //   {
// // // //     id: 6,
// // // //     name: "Burak Şahin",
// // // //     image: "/images/users/5.png",
// // // //     text: "Halı tamiri de yaptırdım, mükemmel sonuç. Güvenilir firma."
// // // //   }
// // // // ];

// // // // const Testimonials = () => {
// // // //   return (
// // // //     <section className="bg-white py-12 px-4">
// // // //       <div className="max-w-screen-xl mx-auto text-center mb-8">
// // // //         <h2 className="text-3xl font-bold text-green-700">Müşteri Yorumları</h2>
// // // //       </div>
// // // //       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-screen-xl mx-auto">
// // // //         {testimonials.map((item) => (
// // // //           <div key={item.id} className="bg-[#f7f7d4] rounded-lg p-6 shadow hover:shadow-lg transition">
// // // //             <div className="flex flex-col items-center text-center">
// // // //               <img
// // // //                 src={item.image}
// // // //                 alt={item.name}
// // // //                 className="w-20 h-20 object-cover rounded-full border-4 border-white shadow-md mb-4"
// // // //               />
// // // //               <h4 className="text-lg font-semibold text-green-800 mb-2">{item.name}</h4>
// // // //               <p className="text-gray-700 text-sm">"{item.text}"</p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default Testimonials;
// // // import React from "react";
// // // import { Star } from "lucide-react";

// // // const testimonials = [
// // //   {
// // //     id: 1,
// // //     name: "Ayşe Yıldız",
// // //     image: "/images/users/4.png",
// // //     date: "3 gün önce",
// // //     text: "Halılarım tertemiz oldu, tam zamanında teslim edildi. Çok memnun kaldım."
// // //   },
// // //   {
// // //     id: 2,
// // //     name: "Mehmet Can",
// // //     image: "/images/users/1.png",
// // //     date: "1 hafta önce",
// // //     text: "Profesyonel ekip, hızlı servis. Koltuklarım ilk günkü gibi oldu."
// // //   },
// // //   {
// // //     id: 3,
// // //     name: "Zeynep Kaya",
// // //     image: "/images/users/3.png",
// // //     date: "2 hafta önce",
// // //     text: "Uygun fiyat, kaliteli hizmet. Perdelerim ışıl ışıl oldu. Teşekkürler!"
// // //   },
// // //   {
// // //     id: 4,
// // //     name: "Ahmet Demir",
// // //     image: "/images/users/2.png",
// // //     date: "3 hafta önce",
// // //     text: "Yorgan yıkama hizmeti gerçekten başarılıydı. Tavsiye ederim."
// // //   },
// // //   {
// // //     id: 5,
// // //     name: "Elif Karaca",
// // //     image: "/images/users/6.png",
// // //     date: "1 ay önce",
// // //     text: "Her seferinde memnun kalıyorum. Hijyen ve kalite bir arada."
// // //   },
// // //   {
// // //     id: 6,
// // //     name: "Burak Şahin",
// // //     image: "/images/users/5.png",
// // //     date: "2 ay önce",
// // //     text: "Halı tamiri de yaptırdım, mükemmel sonuç. Güvenilir firma."
// // //   }
// // // ];

// // // const Testimonials = () => {
// // //   return (
// // //     <section className="bg-white py-10 px-4">
// // //       <div className="max-w-screen-xl mx-auto">
// // //         <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-6">Müşteri Yorumları</h2>
// // //         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
// // //           {testimonials.map((item) => (
// // //             <div
// // //               key={item.id}
// // //               className="bg-[#f8f8f8] border border-gray-300 rounded-xl p-4 shadow-sm hover:shadow-md transition"
// // //             >
// // //               <div className="flex items-start mb-2">
// // //                 <img
// // //                   src={item.image}
// // //                   alt={item.name}
// // //                   className="w-12 h-12 rounded-full object-cover mr-3"
// // //                 />
// // //                 <div>
// // //                   <h4 className="text-sm font-semibold text-gray-800">{item.name}</h4>
// // //                   <div className="flex items-center text-yellow-500 mt-[2px]">
// // //                     {Array(5)
// // //                       .fill()
// // //                       .map((_, i) => (
// // //                         <Star key={i} size={14} fill="currentColor" />
// // //                       ))}
// // //                   </div>
// // //                   <span className="text-xs text-gray-500 mt-1 inline-block">{item.date}</span>
// // //                 </div>
// // //               </div>
// // //               <p className="text-sm text-gray-700 mt-2 leading-relaxed text-justify">{item.text}</p>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Testimonials;
// // import React from "react";
// // import { Star } from "lucide-react";

// // const testimonials = [
// //   {
// //     id: 1,
// //     name: "Elif Nur BÜLBÜL",
// //     image: "/images/users/4.png",
// //     date: "3 gün önce",
// //     text: "Halılarım tertemiz geldi. Açık renk halımdaki çıkaramadığım tüm lekeler gitmiş. Sanki yeni alınmış gibi.. Çok teşekkür ederim, ellerinize sağlık 🙏"
// //   },
// //   {
// //     id: 2,
// //     name: "Kürşad Yıldırım",
// //     image: "/images/users/2.png",
// //     date: "1 ay önce",
// //     text: "İnternet yorumlarına dayanarak vermiş olduğumuz halılar yeni gibi tertemiz oldu. Halileri teslim alıp geri getirmeleri 8 gün sürdü. Halı metrekare..."
// //   },
// //   {
// //     id: 3,
// //     name: "Aycan Özçelik",
// //     image: "/images/users/5.png",
// //     date: "1 hafta önce",
// //     text: "Halılarımı yeni almışım gibi oldu tertemiz olmuş. Önceki halıcı daha da pisletip getirmişti, bu sefer çok memnun kaldım."
// //   },
// //   {
// //     id: 4,
// //     name: "Mehmet Can",
// //     image: "/images/users/1.png",
// //     date: "2 hafta önce",
// //     text: "Profesyonel ekip, hızlı servis. Koltuklarım ilk günkü gibi oldu. Çok teşekkürler."
// //   },
// //   {
// //     id: 5,
// //     name: "Zeynep Kaya",
// //     image: "/images/users/3.png",
// //     date: "3 hafta önce",
// //     text: "Uygun fiyat, kaliteli hizmet. Perdelerim ışıl ışıl oldu. Tavsiye ederim!"
// //   },
// //   {
// //     id: 6,
// //     name: "Ahmet Demir",
// //     image: "/images/users/6.png",
// //     date: "1 ay önce",
// //     text: "Yorgan yıkama hizmeti gerçekten başarılıydı. Her seferinde memnun kalıyorum. Hijyen ve kalite bir arada."
// //   }
// // ];

// // const Testimonials = () => {
// //   return (
// //     <section className="bg-white py-10 px-4">
// //       <div className="max-w-screen-md mx-auto border rounded-xl shadow-lg p-4">
// //         {/* Üst başlık kutusu */}
// //         <div className="border-b pb-4 mb-4">
// //           <h3 className="text-lg font-medium text-gray-900">Yorumlar</h3>
// //           <p className="text-sm text-gray-500">Yorumlar doğrulanmamıştır</p>
// //           <div className="flex items-center mt-2">
// //             <img
// //               src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
// //               alt="Google"
// //               className="w-5 h-5 mr-2"
// //             />
// //             <span className="text-xl font-semibold mr-2">4,5/5</span>
// //             <span className="text-sm text-gray-600">317 yorum</span>
// //           </div>
// //           <button className="mt-3 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-sm font-medium rounded">
// //             + Yorum ekle
// //           </button>
// //         </div>

// //         {/* Yorumlar listesi */}
// //         <div className="space-y-6">
// //           {testimonials.map((item) => (
// //             <div key={item.id} className="border-b pb-4">
// //               <div className="flex items-start">
// //                 <img
// //                   src={item.image}
// //                   alt={item.name}
// //                   className="w-10 h-10 rounded-full mr-3 object-cover"
// //                 />
// //                 <div className="flex-1">
// //                   <div className="flex items-center justify-between">
// //                     <h4 className="text-sm font-semibold text-gray-900">{item.name}</h4>
// //                     <span className="text-xs text-gray-500">{item.date}</span>
// //                   </div>
// //                   <div className="flex items-center text-yellow-500 mt-[2px]">
// //                     {Array(5)
// //                       .fill()
// //                       .map((_, i) => (
// //                         <Star key={i} size={14} fill="currentColor" />
// //                       ))}
// //                   </div>
// //                   <p className="mt-2 text-sm text-gray-800 leading-relaxed">{item.text}</p>
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Testimonials;
// import React from "react";
// import { Star } from "lucide-react";

// const testimonials = [
//   {
//     id: 1,
//     name: "Elif Nur BÜLBÜL",
//     image: "/images/users/4.png",
//     date: "3 gün önce",
//     text: "Halılarım tertemiz geldi. Açık renk halımdaki çıkaramadığım tüm lekeler gitmiş. Sanki yeni alınmış gibi.. Çok teşekkür ederim, ellerinize sağlık 🙏"
//   },
//   {
//     id: 2,
//     name: "Kürşad Yıldırım",
//     image: "/images/users/2.png",
//     date: "1 ay önce",
//     text: "İnternet yorumlarına dayanarak vermiş olduğumuz halılar yeni gibi tertemiz oldu. Halileri teslim alıp geri getirmeleri 8 gün sürdü. Halı metrekare..."
//   },
//   {
//     id: 3,
//     name: "Aycan Özçelik",
//     image: "/images/users/5.png",
//     date: "1 hafta önce",
//     text: "Halılarımı yeni almışım gibi oldu tertemiz olmuş. Önceki halıcı daha da pisletip getirmişti, bu sefer çok memnun kaldım."
//   },
//   {
//     id: 4,
//     name: "Mehmet Can",
//     image: "/images/users/1.png",
//     date: "2 hafta önce",
//     text: "Profesyonel ekip, hızlı servis. Koltuklarım ilk günkü gibi oldu. Çok teşekkürler."
//   },
//   {
//     id: 5,
//     name: "Zeynep Kaya",
//     image: "/images/users/3.png",
//     date: "3 hafta önce",
//     text: "Uygun fiyat, kaliteli hizmet. Perdelerim ışıl ışıl oldu. Tavsiye ederim!"
//   },
//   {
//     id: 6,
//     name: "Ahmet Demir",
//     image: "/images/users/6.png",
//     date: "1 ay önce",
//     text: "Yorgan yıkama hizmeti gerçekten başarılıydı. Her seferinde memnun kalıyorum. Hijyen ve kalite bir arada."
//   }
// ];

// const Testimonials = () => {
//   return (
//     <section className="bg-white py-10 px-4">
//       <div className="max-w-screen-md mx-auto border rounded-xl shadow-lg p-4">
//         {/* Üst başlık kutusu */}
//         <div className="border-b pb-4 mb-4">
//           <h3 className="text-lg font-medium text-gray-900">Yorumlar</h3>
//           <p className="text-sm text-gray-500">Yorumlar doğrulanmamıştır</p>
//           <div className="flex items-center mt-2">
//             <img
//               src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
//               alt="Google"
//               className="w-5 h-5 mr-2"
//             />
//             <span className="text-xl font-semibold mr-2">4,5/5</span>
//             <span className="text-sm text-gray-600">317 yorum</span>
//           </div>
//           <button className="mt-3 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-sm font-medium rounded">
//             + Yorum ekle
//           </button>
//         </div>

//         {/* Yorumlar listesi */}
//         <div className="space-y-6">
//           {testimonials.map((item) => (
//             <div key={item.id} className="border-b pb-4">
//               <div className="flex items-start">
//                 <img
//                   src={item.image}
//                   alt={item.name}
//                   className="w-10 h-10 rounded-full mr-3 object-cover"
//                 />
//                 <div className="flex-1">
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-sm font-semibold text-gray-900">{item.name}</h4>
//                     <span className="text-xs text-gray-500">{item.date}</span>
//                   </div>

//                   {/* Google yorumları etiketi */}
//                   <a
//                     href="#"
//                     className="text-xs text-blue-600 font-medium inline-flex items-center gap-1 mt-1"
//                   >
//                     <img
//                       src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
//                       alt="Google"
//                       className="w-4 h-4"
//                     />
//                     Google yorumları
//                   </a>

//                   {/* Yıldızlar */}
//                   <div className="flex items-center text-yellow-500 mt-1">
//                     {Array(5)
//                       .fill()
//                       .map((_, i) => (
//                         <Star key={i} size={14} fill="currentColor" />
//                       ))}
//                   </div>

//                   {/* Yorum metni */}
//                   <p className="mt-2 text-sm text-gray-800 leading-relaxed">{item.text}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;
import React from "react";
import { Star } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "Zekiye BÜLBÜL",
    image: "/images/users/4.png",
    date: "3 gün önce",
    text: "Halılarım tertemiz geldi. Açık renk halımdaki çıkaramadığım tüm lekeler gitmiş. Sanki yeni alınmış gibi.. Çok teşekkür ederim, ellerinize sağlık 🙏"
  },
  {
    id: 2,
    name: "Ertan Yıldırım",
    image: "/images/users/2.png",
    date: "1 ay önce",
    text: "İnternet yorumlarına dayanarak vermiş olduğumuz halılar yeni gibi tertemiz oldu. Halileri teslim alıp geri getirmeleri 8 gün sürdü. Halı metrekare..."
  },
  {
    id: 3,
    name: "İsmet Özçelik",
    image: "/images/users/5.png",
    date: "1 hafta önce",
    text: "Halılarımı yeni almışım gibi oldu tertemiz olmuş. Önceki halıcı daha da pisletip getirmişti, bu sefer çok memnun kaldım."
  },
  {
    id: 4,
    name: "Mehmet Can",
    image: "/images/users/1.png",
    date: "2 hafta önce",
    text: "Profesyonel ekip, hızlı servis. Koltuklarım ilk günkü gibi oldu. Çok teşekkürler."
  },
  {
    id: 5,
    name: "Zeynep Kaya",
    image: "/images/users/3.png",
    date: "3 hafta önce",
    text: "Uygun fiyat, kaliteli hizmet. Perdelerim ışıl ışıl oldu. Tavsiye ederim!"
  },
  {
    id: 6,
    name: "Pınar Demir",
    image: "/images/users/6.png",
    date: "1 ay önce",
    text: "Yorgan yıkama hizmeti gerçekten başarılıydı. Her seferinde memnun kalıyorum. Hijyen ve kalite bir arada."
  }
];

const Testimonials = () => {
  const handleClick = () => {
    alert("Lütfen üye girişi için firmamızla iletişime geçin.");
  };

  return (
    <section className="bg-white py-10 px-4">
      <div className="max-w-screen-xl mx-auto border rounded-xl shadow-lg p-4">
        {/* Üst başlık kutusu */}
        <div className="border-b pb-4 mb-6">
          <h3 className="text-lg font-medium text-gray-900">Yorumlar</h3>
          <div className="flex items-center mt-2">
            <img
              src="/images/google.png"
              alt="Google"
              className="w-5 h-5 mr-2"
            />
            <span className="text-xl font-semibold mr-2">4,5/5</span>
            <span className="text-sm text-gray-600">317 yorum</span>
          </div>
          <button className="mt-3 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-sm font-medium rounded">
            + Yorum ekle
          </button>
        </div>

        {/* Yorumlar grid görünüm */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((item) => (
            <div key={item.id} className="border-b pb-4">
              <div className="flex items-start">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-10 h-10 rounded-full mr-3 object-cover"
                />
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-gray-900">{item.name}</h4>
                    <span className="text-xs text-gray-500">{item.date}</span>
                  </div>

                  {/* Google yorumları etiketi */}
                  <span
  className="text-xs text-blue-600 font-medium inline-flex items-center gap-1 mt-1 cursor-default"
>
  <img
    src="/images/google.png"
    alt="Google"
    className="w-4 h-4"
  />
  Google yorumları
</span>

                  {/* Yıldızlar */}
                  <div className="flex items-center text-yellow-500 mt-1">
                    {Array(5)
                      .fill()
                      .map((_, i) => (
                        <Star key={i} size={14} fill="currentColor" />
                      ))}
                  </div>

                  {/* Yorum metni */}
                  <p className="mt-2 text-sm text-gray-800 leading-relaxed">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Alt buton */}
        <div className="text-center mt-8">
          <button
            onClick={handleClick}
            className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
          >
            Diğer yorumlar için tıklayın
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
